<template>
	<div class="">
		<div class="flex items-center gap-1 cursor-pointer" @click="expand()">
			<div>
				<IconSparkles :color_prop="colorGold" />
			</div>

			<div class="grow font-semibold">
				Instant Return on Gold (RoG)
			</div>

			<div>
				{{ currencySymbol }} {{ cashbackShown }}
			</div>

			<div class="">
				<IconArrow :direction_prop="arrowDirection" />
			</div>
		</div>

		<div :class="`text-2xs mt-4 ${isExpanded ? 'block' : 'hidden'}`">
			Place an order to get a potential payment of {{ currencySymbol }} {{ potentialPayment}} after Instant RoG deduction when the order is successful
		</div>
	</div>
</template>

<script>
import { Decimal } from 'decimal.js'

import utils from '../../utils'

import IconArrow from '../icons/IconArrow.vue'
import IconSparkles from '../icons/IconSparkles.vue'

export default {
	name: "InstantROG_TradeTicket",

	components: {
		IconArrow,
		IconSparkles
	},

	props: {
		orderDetailsIdr: [Object],
	},

	data() {
		return {
			isExpanded: false,
		}
	},

	computed: {
		colorGold() {
			return getComputedStyle(document.documentElement).getPropertyValue('--color-gold')
		},

		arrowDirection() {
			if (this.isExpanded) {
				return 'up'
			} else {
				return 'down'
			}
		},

		currency() {
			return this.$store.state.currency
		},

		cashbackIdr() {
			const contractValueIdr = this.orderDetailsIdr.contractValue
			const returnValue = Decimal.mul(contractValueIdr, 0.01).toDecimalPlaces(0, Decimal.ROUND_DOWN)
			return returnValue
		},

		cashbackUsd() {
			const cashbackIdr = this.cashbackIdr
			const streamingRateBuy = this.$store.getters.getStreamingRate.streamBuy
			const returnValue = Decimal.div(cashbackIdr, streamingRateBuy).toDecimalPlaces(this.$store.state.fractionDigit[this.currency], Decimal.ROUND_DOWN)
			return returnValue
		},

		cashbackShown() {
			let cashback = 0
			if (this.currency == 'idr') {
				cashback = this.cashbackIdr
			} else {
				cashback = this.cashbackUsd
			}

			return utils.currencyFormat(cashback.toFixed(this.$store.state.fractionDigit[this.currency]))
		},

		potentialPayment() {
			const finalPaymentIdr = this.$store.getters.paymentMethod == 'rped' ? this.orderDetailsIdr.finalAmount : this.orderDetailsIdr.totalTypeC
			const cashbackIdr = this.cashbackIdr
			const potentialPaymentIdr = Decimal.sub(finalPaymentIdr, cashbackIdr)

			return utils.currencyFormat(potentialPaymentIdr.toFixed(this.$store.state.fractionDigit[this.currency]))
		}
	},

	methods: {
		expand() {
			this.isExpanded = !this.isExpanded

		}
	}
}
</script>

<style scoped></style>